import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

export const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>{t('footer.copyright')}</p>
        <div className="language-switcher">
          <button onClick={() => i18n.changeLanguage('en')}>English (CA)</button>
          <button onClick={() => i18n.changeLanguage('fr')}>Français (CA)</button>
        </div>
      </div>
    </footer>
  );
};
